type LoginUserPayload = {
  data?: {
    user?: Record<string, any>;
    tenant?: Record<string, any>;
    permissions?: Record<string, any> | null;
    token?: string;
  };
  message?: string;
  user?: Record<string, any>;
};

export function mapLoginResponseToApiData(payload: LoginUserPayload) {
  const user = payload.data?.user ?? payload.user;
  if (!user) return null;

  return {
    firstName: user.firstName ?? '',
    lastName: user.lastName ?? '',
    role: user.role ?? '',
    roleId: user.roleId ?? user.roles?.[0]?.id ?? '',
    lifecycleStatus: user?.tenant?.tenantSetting
      ? user?.tenant?.tenantSetting[0]?.showLifecycleStages
      : '',
    email: user.email ?? '',
    tenantId: user.tenantId ?? '',
    token: payload.data?.token ?? user.token ?? '',
    message: payload.message ?? '',
    teamId: user.teamId ?? '',
    id: user.id ?? '',
    tenant: payload.data?.tenant ?? user.tenant ?? '',
    ProfileURL: user.ProfileURL ?? '',
    userExtId: user.userExtId ?? '',
    userExtPassword: user.userExtPassword ?? '',
    extNumber: user.extNumber ?? '',
    permissions: payload.data?.permissions ?? user.permissions ?? null,
    customFieldModules: user.moduleFields ?? [],
    messageSignature: user.messageSignature ?? '',
  };
}
